import { render, staticRenderFns } from "./ChangeDisplayOrder.vue?vue&type=template&id=035cb8f8&scoped=true&"
import script from "./ChangeDisplayOrder.vue?vue&type=script&lang=ts&"
export * from "./ChangeDisplayOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeDisplayOrder.vue?vue&type=style&index=0&id=035cb8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035cb8f8",
  null
  
)

export default component.exports